import styled, { css } from 'styled-components';
import { FormContainerFieldContainer } from '../../form-container-field';
import { IconContainer } from '../../icon';
import Typography from '../../typography';
import { pxToRem } from '../../../design-tokens/style-utilities';
const COLOR_PREVIEW_SIZE = 64;
const CONTAINER_SIZE_L = 204;
const CONTAINER_SIZE_XL = 224;
/**
 * FormInputColor Color
 */
export const formInputColorColorStyles = ({ theme }) => css `
	width: ${pxToRem(COLOR_PREVIEW_SIZE)};
	height: ${pxToRem(COLOR_PREVIEW_SIZE)};
	border: ${pxToRem(theme.borderWidth['2'])} solid ${theme.colors.medium.borderFormField};
	border-radius: ${pxToRem(theme.borderRadius.m)};
	position: relative;
	margin-right: ${pxToRem(theme.spacing['200'])};
	flex-shrink: 0;

	&::before {
		display: none;
	}
`;
export const FormInputColorColor = styled.div `
	${formInputColorColorStyles}
`;
/**
 * FormInputColor Container
 */
export const formInputColorContainerStyles = ({ theme, $isDisabled, $isInValid, }) => css `
	&& {
		width: 100%;
		display: flex;
		padding-right: ${pxToRem(theme.spacing['200'])};
		padding-bottom: ${pxToRem(theme.spacing['200'])};
		cursor: pointer;
	}

	${!$isDisabled &&
    css `
		&:hover ${FormInputColorColor} {
			border-color: ${theme.colors.highlight.borderHover};
		}
	`}

	input:checked + ${FormInputColorColor},
	input:focus + ${FormInputColorColor} {
		border-color: ${theme.colors.highlight.borderSelected};
	}

	${$isInValid &&
    css `
		${FormInputColorColor} {
			border-color: ${theme.colors.error.borderFormField};
		}
	`}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		${FormContainerFieldContainer}[data-size="l"] & {
			width: ${pxToRem(CONTAINER_SIZE_L)};
		}
		${FormContainerFieldContainer}[data-size="xl"] & {
			width: ${pxToRem(CONTAINER_SIZE_XL)};
		}
	}
`;
export const FormInputColorContainer = styled.label `
	${formInputColorContainerStyles}
`;
/**
 * FormInputColorInput
 */
export const FormInputColorInputStyles = () => css `
	opacity: 0;
	position: absolute;
	width: 0;
`;
export const FormInputColorInput = styled.input `
	${FormInputColorInputStyles}
`;
/**
 * FormInputColor ColorInner
 */
export const formInputColorColorPreviewStyles = ({ theme, $isDisabled, $isDark, $useGradient, $image, $color, }) => css `
	width: 100%;
	height: 100%;
	background-position: left;
	border-radius: ${pxToRem(Number(theme.borderRadius.m) - Number(theme.borderWidth['2']))};

	${$color &&
    !$isDisabled &&
    !$useGradient &&
    css `
		background: ${$color};

		&::before {
			position: absolute;
			content: '';
			bottom: 0;
			left: 0;
			width: 100%;
			height: 50%;
			background-color: rgb(255 255 255 / 30%);
		}
	`}

	${$useGradient &&
    css `
		background:
			${$isDark
        ? theme.colors.gradients.overlayColorPickerDark
        : theme.colors.gradients.overlayColorPickerLight},
			${$color};
		background-size: cover;
	`}

	${$image &&
    css `
		background: url('${$image}');
		background-size: cover;
	`}

	${$isDisabled &&
    css `
		display: grid;
		background: ${theme.colors.extralight.bgFormFieldDisabled};
		border-color: ${theme.colors.light.borderFormFieldDisabled};

		${IconContainer} {
			place-self: center center;
			color: ${theme.colors.medium.iconInactive};
		}
	`}
`;
export const FormInputColorColorPreview = styled.div `
	${formInputColorColorPreviewStyles}
`;
/**
 * FormInputColor Text
 */
export const formInputColorTextStyles = () => css `
	width: 100%;
	position: relative;
`;
export const FromInputColorText = styled.div `
	${formInputColorTextStyles}
`;
/**
 * FormInputColor Label
 */
export const formInputColorLabelStyles = ({ theme, $isDisabled, }) => css `
	margin: 0;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;

	&:only-child {
		width: 100%;
		top: 45%;
		position: absolute;
		transform: translateY(-50%);
	}

	${$isDisabled &&
    css `
		color: ${theme.colors.base.textTitlesInactive};
	`}
`;
export const FormInputColorLabel = styled(Typography).attrs({
    variant: 'content-subtitle',
}) `
	${formInputColorLabelStyles}
`;
/**
 * FormInputColor Price
 */
export const formInputColorPriceStyles = ({ theme }) => css `
	margin: 0;
	color: ${theme.colors.informative.textPrice};
`;
export const FromInputColorPrice = styled(Typography).attrs({
    variant: 'price-text-md',
    tagName: 'p',
}) `
	${formInputColorPriceStyles}
`;
/**
 * FormInputColor Text
 */
export const formInputColorDescriptionStyles = ({ theme }) => css `
	margin: 0;
	color: ${theme.colors.informative.textDescription};
`;
export const FormInputColorDescription = styled(Typography).attrs({
    variant: 'support-text',
    tagName: 'p',
}) `
	${formInputColorDescriptionStyles}
`;
